export const SET_NEWSLETTERS = 'SET_NEWSLETTERS';
export const LIST_NEWSLETTERS = 'LIST_NEWSLETTERS';
export const REMOVE_NEWSLETTER = 'REMOVE_NEWSLETTER';
export const LIST_AUDIENCE = 'LIST_AUDIENCE';
